import { setPageStateById } from '../PageContext';

export const disableLoading = (setState: setPageStateById) => () => {
  setState('DISABLE_LOADING', (s) => {
    return {
      ...s,
      loadingDisabled: true,
    };
  });
};
